<template>
  <div v-html="html" id="htmldoc" style="padding: 20px;">
  </div>
</template>

<script>
export default {
  props: ['html']
}
</script>

<style scoped>
h1 {
  color: red;
}
</style>